import { apiCall } from "./Common";
import {
  getCachedAppSettings,
  setCachedAppSettings,
  getSettingsLoadPromise,
  setSettingsLoadPromise,
  clearSettingsLoadPromise,
} from "./settingsCache";

export async function fetchAppSettings(options = {}) {
  const force = options === true || options?.force === true;
  const cached = getCachedAppSettings();
  if (!force && cached) {
    return { ...cached };
  }

  const inflight = getSettingsLoadPromise();
  if (!force && inflight) {
    return inflight;
  }

  const promise = (async () => {
    const res = await apiCall("settings", "GET");
    if (!res?.success) {
      throw new Error(res?.message || "Failed to load settings");
    }
    const data = res.data || { customCss: "", customJs: "" };
    setCachedAppSettings(data);
    return data;
  })();

  setSettingsLoadPromise(promise);
  try {
    return await promise;
  } finally {
    clearSettingsLoadPromise();
  }
}

export async function saveAppSettings(settings) {
  const res = await apiCall("settings", "PUT", settings);
  if (!res?.success) {
    throw new Error(res?.message || "Failed to save settings");
  }
  const data = res.data || {};
  if (data.settings) {
    setCachedAppSettings(data.settings);
  } else if (settings) {
    setCachedAppSettings(settings);
  }
  return data;
}

/** Warm settings cache once per session (see appBootstrap.js). */
export function prefetchAppSettings() {
  if (getCachedAppSettings()) {
    return Promise.resolve(getCachedAppSettings());
  }
  return fetchAppSettings().catch(() => null);
}
